export default __webpack_public_path__ + "static/media/coin-vertical.11b17377.png";